module.exports = __webpack_public_path__ + "static/img/SGShaolinFortunes243.9e0598f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SGShaolinFortunes243.jpg
// module id = qc2w
// module chunks = 0